/**
 * ROC 7
 * Last update: 10-17-2016 4:07:36 PM UTC
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/UI/SetupGlobals',[
    'jquery',
    './Helpers',
    'global/Logger',
	'plugins/jquery.matchHeight',
	'plugins/responsive-table'
], function ($, Helpers, Logger) {
    'use strict';
    Logger.debug('Setting up Global JS...');

    // hack due to some plugins mapping to wrong global jquery
    var other$ = jQuery;

    /*
	 * Switching img src based on data attr
	 * Initial img injected into src attr is lg (server side)
	 * After initial inject the handler runs and resizes images.
	 */	
		
	/* Checkbox to select */	
	function dropDownSelectQuote() {
		var valueOnLoadWrap = $(".dropp-quote input[name='rbQuoteStatus']").parent();
		var valueOnLoad = $(".dropp-quote input[name='rbQuoteStatus']:checked").prev().text();
		$('.js-quote-value').text(valueOnLoad);
		valueOnLoadWrap.first().addClass("js-quote-open");
		valueOnLoadWrap.each(function() {
			$(this).hover(function(e) {
				$(this).addClass("js-quote-hover");
				$(this).prevAll().removeClass("js-quote-hover");				
				$(this).nextAll().removeClass("js-quote-hover");
				$(this).prevAll().not(".js-quote-open.js-quote-hover").addClass("js-quote-hover-off");
				$(this).nextAll().not(".js-quote-open.js-quote-hover").addClass("js-quote-hover-off");
			});
			valueOnLoadWrap.mouseleave(function(e) {
				valueOnLoadWrap.removeClass("js-quote-hover");
			});
			if ($(this).hasClass("js-quote-hover")) {
				$(this).prev().removeClass("js-quote-hover");				
				$(this).next().removeClass("js-quote-hover");
			}
		});
		// Default dropdown action to show/hide dropdown content
		$('.js-dropp-quote-action').click(function(e) {
			e.preventDefault();
			$(this).toggleClass('js-quote-open');
			$(this).parent().next('.dropp-quote-body').toggleClass('js-quote-open');			
		});
		// Using as fake input select dropdown
		$('.quotes-radioBtn.checkbox-quote').click(function() {
			$(this).addClass('js-quote-open').removeClass("js-quote-hover-off").siblings().removeClass('js-quote-open').removeClass("js-quote-hover-off");
			$('.dropp-quote-body,.js-dropp-action').removeClass('js-quote-open');
			setTimeout(function(){
				if (!$(".dropp-quote-body").hasClass("js-quote-open") === true) {
					$(".quotes-radioBtn.checkbox-quote.js-quote-hover-off").removeClass("js-quote-hover-off");
				}				
			},500);			
		});
		// get the value of checked input radio and display as dropp title
		$('input[name="rbQuoteStatus"]').change(function() {
			var value = $("input[name='rbQuoteStatus']:checked").prev().text();
			$('.js-quote-value').text(value);
		});
		$(window).click(function() {
			$('.dropp-quote-body,.js-dropp-action').removeClass('js-quote-open');
		});

		$('.dropp-quote').click(function(event){
			event.stopPropagation();
		});		
	};
	
	/* Custom select */	
	function selectDropdownWrap() {	
		$('select.select-dropdown-custom').each(function () {
			var $this = $(this),numberOfOptions = $(this).children('option').length;

			$this.addClass('select-hidden');
			$this.wrap('<div class="select-dropdown-wrap"></div>');
			$this.after('<div class="select-styled"></div>');

			var $styledSelect = $this.next('div.select-styled');
			$styledSelect.html('<div class="select-styled-in">'+$this.children('option').eq(0).text()+'</div>');
			//$styledSelect.wrapInner('<div class="select-styled-in"/>');

			var $list = $('<ul />', {
			'class': 'select-options' }).
			insertAfter($styledSelect);

			for (var i = 0; i < numberOfOptions; i++) {
				$('<li />', {
				text: $this.children('option').eq(i).text(),
				rel: $this.children('option').eq(i).val() }).
				appendTo($list);
			};

			var $listItems = $list.children('li');
			var $listItem = $('ul.select-options li');
			$('ul.select-options li:first-child').addClass("select-active");
			$listItem.each(function() {
				$(this).hover(function(e) {
					$(this).addClass("select-hover");
					$(this).prevAll().removeClass("select-hover");				
					$(this).nextAll().removeClass("select-hover");
					$(this).prevAll().not(".select-active.select-hover").addClass("select-hover-off");
					$(this).nextAll().not(".select-active.select-hover").addClass("select-hover-off");
				});
				$listItem.mouseleave(function(e) {
					$listItem.removeClass("select-hover");
				});
				if ($(this).hasClass("select-hover")) {
					$(this).prev().removeClass("select-hover");				
					$(this).next().removeClass("select-hover");
				}
			});			
			
			$styledSelect.click(function (e) {
				e.stopPropagation();
				$('div.select-styled.active').not(this).each(function () {
				$(this).removeClass('active').next('ul.select-options').removeClass("select-active");
				});
				$(this).toggleClass('active').next('ul.select-options').toggleClass("select-active");
			});

			$listItems.click(function (e) {
				e.stopPropagation();
				$styledSelect.html('<div class="select-styled-in">'+$(this).text()+'</div>').removeClass('active');
				$this.val($(this).attr('rel'));
				$(this).toggleClass('select-active');
				$list.removeClass("select-active");
				$(this).addClass('select-active').removeClass("select-hover-off").siblings().removeClass('select-active').removeClass("select-hover-off");
				setTimeout(function(){
					if (!$(".select-options").hasClass("select-active") === true) {
						$(".select-options li.select-active.select-hover-off").removeClass("select-hover-off");
					}				
				},500);
			});
			$(window).click(function() {
				$styledSelect.removeClass('active');
				$list.removeClass("select-active");
			});

			$('.select-dropdown-wrap').click(function(event){
				event.stopPropagation();
			});
		});
	};
	
	$(document).ready(function(){
		dropDownSelectQuote();	
		selectDropdownWrap();
		if ($('.responsive-table').length > 0) {
			$(".responsive-table").ResponsiveTables({
				smallPaddingCharNo: 13,
				mediumPaddingCharNo: 18,
				largePaddingCharNo: 30
			});
		}		
		
        var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
        if (window.location.hash && isChrome) {
            setTimeout(function () {
                var hash = window.location.hash;
                window.location.hash = "";
                window.location.hash = hash;
            }, 300);
        }		
		
		setTimeout(function(){
			$(".panel.panel-default [data-roc-tab=\"Product Reviews\"] .panel-title").attr("id", 'writeReviewAnchor');
		},2000);		
		
		
		
		setTimeout(function(){
			if ($(window).width() < 400) {	
				$(".headerLinks-wrapper-cell").find(".slice-log-name").each(function() {
					if($(this).text().length > 11) {
						$(this).text($(this).text().substr(0,11).split("").slice(0, -2).join("") + "...");
					}
				});
			}
			equalheight(".order-history-search-wrapper .roc-order-history-label");
			equalheight(".invoice-history-search-wrapper .roc-invoice-history-label");
		},400);		
		
		setTimeout(function(){
			$("#shopForOrganizationSelector:has(div.headerLinks-text)").parent().addClass("shop-for-organization");
		},500);		
		
		setTimeout(function(){
			$("#shopForOrganizationSelector:has(div.headerLinks-text)").parent().addClass("visible-organizer");
			$(".headerLinks-wrapper-cell--account:has(p.loggedIn)").parent().parent().parent().addClass("header-links-logged-in");
			$(".headerTop .headerLinks-wrapper").addClass("visible");
		},700);
	
		
		setTimeout(function(){
			equalheight('.recentlyViewedWrapper .slide-content');
		},1000);		
		
	});

	$(window).resize(function(){
		equalheight('.recentlyViewedWrapper .slide-content');
		equalheight(".order-history-search-wrapper .roc-order-history-label");
		equalheight(".invoice-history-search-wrapper .roc-invoice-history-label");		
	});	
	
	$(document).ajaxComplete(function( event, request, settings ) {

		setTimeout(function(){
			$(".productListInner .itemWrapper").each(function() {
				$(this).find(".hawk-brokenImage").attr("src", "/ResourcePackages/Roc/assets/images/na-images/na-m.jpg");
			});	
		},1000);

	});	
	
	function setRandomClass() {
		var teamList = $('.random__banner-list');
		var teamItem = teamList.find('.random__banner-item');
		var number = teamItem.length;
		var random = Math.floor((Math.random() * number));
		teamItem.eq(random).addClass('random__banner-item_active').attr('aria-hidden', 'false').siblings().removeClass('random__banner-item_active').attr('aria-hidden', 'true');
	}

	$(window).load(function () {
		if($('.random__banner-list').length > 0) {
			setRandomClass();
		}
	});
	
    var imgSrcHandler = Helpers.debounce(function () {

        if (Helpers.resizer.windowWidth >= 1400) {
            $("[data-img-lg]").each(function () {
                var imgSrc = $(this).data("img-lg");
                $(this).attr("src", imgSrc);

                if ($(this).hasClass('bg-img')) {
                    console.log('lg');
                }
            });
        } else if (Helpers.resizer.windowWidth >= 1200) {
            $("[data-img-mlg]").each(function () {
                var mdImgSrc = $(this).data("img-mlg");
                $(this).attr("src", mdImgSrc);

                if ($(this).hasClass('bg-img')) {
                    console.log('mlg');
                }
            })
        } else if (Helpers.resizer.windowWidth >= 992) {
            $("[data-img-md]").each(function () {
                var mdImgSrc = $(this).data("img-md");
                $(this).attr("src", mdImgSrc);

                if ($(this).hasClass('bg-img')) {
                    console.log('md');
                }
            })
        } else if (Helpers.resizer.windowWidth >= 768) {
            $("[data-img-sm]").each(function () {
                var smImgSrc = $(this).data("img-sm");
                $(this).attr("src", smImgSrc);

                if ($(this).hasClass('bg-img')) {
                    console.log('sm');
                }
            })
        } else {
            $("[data-img-xs]").each(function () {
                var xsImgSrc = $(this).data("img-xs");
                $(this).attr("src", xsImgSrc);

                if ($(this).hasClass('bg-img')) {
                    console.log('xs');
                }
            })
        }
    }, 1);
	
    imgSrcHandler();

    // Binding all the named functions
    $(window).on("resize", imgSrcHandler);
		
    var SetupGlobals = {};

    return SetupGlobals;
});

